import { Flex } from '@mantine/core';
import * as Sentry from '@sentry/react';
import { LineChartLegendItem } from '../../../../components/line-chart/line-chart-legend-item';
import { hasDataForItem } from './line-chart.helpers';
import type { LineChartLegendProps } from './line-chart.type';

export const LineChartLegend = ({
  selectedItems,
  hoveredItem,
  setHoveredItem,
  itemColors,
  formatItemName,
  chartData,
  labelMaxLength,
}: LineChartLegendProps) => {
  try {
    return (
      <Flex justify="center" align="center" gap="md" wrap="wrap" h="100%">
        {selectedItems.map((item) => {
          const isHovered = hoveredItem === null || hoveredItem === item.id;
          const itemHasData = hasDataForItem(chartData, item.id);
          const enableTooltip = labelMaxLength !== undefined && item.name.length > labelMaxLength;

          return (
            <LineChartLegendItem
              key={item.id}
              value={item.id}
              label={formatItemName(item.name)}
              fullLabel={item.name}
              color={itemColors[item.id]}
              isHovered={isHovered}
              hasData={itemHasData}
              onMouseEnter={setHoveredItem}
              onMouseLeave={() => setHoveredItem(null)}
              enableTooltip={enableTooltip}
            />
          );
        })}
      </Flex>
    );
  } catch (error) {
    Sentry.captureException(error);
    return null;
  }
};
